import { render } from "./Markdown.vue?vue&type=template&id=79ba1ab0&ts=true"
import script from "./Markdown.vue?vue&type=script&lang=ts"
export * from "./Markdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__